import React from "react";
import BeyondBrilliant from "../../../images/about-us/BeyondBrilliant-Tagline-White.png";
import NcImage from "shared/NcImage/NcImage";
import NcLink from "shared/NcLink/NcLink";
import ButtonCSCLed from "shared/Button/ButtonCSCLed";

type GetInTouchPage = {
  title: string;
  message: string;
  linkButtonlable: string;
  navLink: string;
};

const GetInTouchPages: GetInTouchPage[] = [
  {
    title: `Lets Get in Touch!`,
    message: `We have two order centers and three warehouses across Canada so we always have someone ready to take your call, and ship your products.`,
    linkButtonlable: `Contact Us Form`,
    navLink: `/contact-us`,
  },
  {
    title: `Policies & Forms`,
    message: `Find all our policies and forms for warranties, shipping, returns, and more—everything you need for a smooth experience with CSC LED.`,
    linkButtonlable: `Policies & Forms`,
    navLink: `/policy-forms`,
  },
];

const AboutUsGetInTouch = () => {
  return (
    <div className="nc-AboutUsGetInTouch">
      <div className="flex justify-center py-16 bg-csccolor">
        <NcImage
          containerClassName="w-48 sm:w-96"
          className="object-contain w-full h-full"
          src={BeyondBrilliant}
        />
      </div>
      <div className="flex flex-col sm:flex-row bg-stone-100 justify-center">
        {GetInTouchPages.map((item, idx) => (
          <div
            key={idx}
            className={`p-10 flex flex-col items-center justify-center text-center rounded-lg max-w-lg`}
          >
            <div className={`text-2xl font-bold text-csccolor mb-4`}>
              {item.title}
            </div>
            <p className="mb-5">{item.message}</p>
            <NcLink to={item.navLink} className="w-full">
              <ButtonCSCLed className="w-full sm:w-fit">{item.linkButtonlable}</ButtonCSCLed>
            </NcLink>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AboutUsGetInTouch;
